const _t = require('counterpart');
export function formatCurrency(value, currency) {
    return new Intl.NumberFormat(_t.getLocale(), { style: 'currency', currency }).format(value);
}
